export default __webpack_public_path__ + "static/Barranquilla-disabled-6ff28a6b879e8d7a0360448824d9e833.svg";